import { SearchInputFilterItems } from "features/filters/components";

import useAudienceFilters from "../../../../hooks/useAudienceFilters";

import type {
  AudienceFacetItem,
  AudienceFacets,
  AudienceFilters as AudienceFiltersType,
} from "../../../../types";

interface AudienceFiltersProps {
  audienceFacets: AudienceFacets;
  isLoadingFacets: boolean;
  filterKey: keyof Omit<AudienceFiltersType, "keyword">;
  filters: AudienceFiltersType;
  setFilters: (filters: AudienceFiltersType) => void;
}
export default function AudienceFilterOptions({
  audienceFacets,
  isLoadingFacets,
  filterKey,
  filters,
  setFilters,
}: AudienceFiltersProps) {
  const { toggleFilterItem, setFilterValue } = useAudienceFilters(
    filters,
    setFilters,
  );

  let facetOptions: AudienceFacetItem[] = [];
  if (audienceFacets) {
    facetOptions =
      filterKey === "premium"
        ? [
            { id: "all", name: "All", target_count: 0 },
            // this should be done on the server, facet names should be corrected
            ...audienceFacets[filterKey].map(({ name, id, ...rest }) => ({
              name: name === "true" ? "Premium" : "Not premium",
              id: id.toString(),
              ...rest,
            })),
          ]
        : // this should be done on the server, invalid values shouldn't be returned by the api
          audienceFacets[filterKey].filter(({ id }) => !!id);
  }

  return (
    <SearchInputFilterItems
      isLoading={isLoadingFacets}
      getFilteredItems={(lowercaseSearchKeyword) =>
        facetOptions
          .filter(({ name }) =>
            name.toLowerCase().includes(lowercaseSearchKeyword),
          )
          .map((facet) => ({ ...facet, id: facet.id.toString() }))
      }
      getIsChecked={({ id }) => {
        if (filterKey === "premium") {
          return (
            id ===
            (filters.premium !== undefined ? filters.premium.toString() : "all")
          );
        } else {
          return filters[filterKey].includes(id);
        }
      }}
      onSelectionChange={(type, item) => {
        if (filterKey === "premium") {
          setFilterValue(
            filterKey,
            item.id === "all" ? undefined : item.id === "true",
          );
        } else {
          if (type === "toggle") {
            toggleFilterItem(filterKey, item.id);
          } else {
            setFilterValue(filterKey, [item.id]);
          }
        }
      }}
      renderLabel={({ name }) => name}
    />
  );
}
